import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import usePerfil from "../../../hooks/usePerfil";
import Swal from "sweetalert2";

export default function ModalPassword({ modal, toggle, Id, Nombre, token }) {
  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { error, message, success, PasswordUpdateService } = usePerfil();

  useEffect(() => {
    if (!modal) {
      setPassword("");
      setShowPassword(false);
    }
  }, [modal]);

  const updatePassword = () => {
    if (!Password) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es obligatoria",
      });
      return;
    }

    const data = new FormData();
    data.append("user_id", Id);
    data.append("password", Password);
    PasswordUpdateService(data, token);

    Swal.fire({
      title: "Actualizando contraseña",
      text: "Loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      icon: "question",
      onOpen: () => {
        Swal.showLoading();
      },
    });
  };

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
      toggle();
    }
  }, [message, success]);

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader className="backend_titulo" toggle={toggle}>
        Restablecer contraseña {Nombre ? `de ${Nombre}` : ""}
      </ModalHeader>
      <ModalBody>
        <div className="crud-modal-field">
          <label className="crud-modal-label">Nueva contraseña</label>
          <div className="crud-password-wrap">
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Nueva contraseña"
              value={Password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="crud-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
            </button>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="backend_boton" onClick={updatePassword}>
          Actualizar contraseña
        </Button>
      </ModalFooter>
    </Modal>
  );
}
